import Service from "../Service";
import AuthService from "../AuthService";

const Common = {
  getProvince() {
    return Service.get("/api/address/province");
  },
  getDistricts(id) {
    return Service.get(`/api/address/district/${id}`);
  },
  getSubDistricts(id) {
    return Service.get(`/api/address/sub-district/${id}`);
  },
  getRole() {
    return Service.get("/api/get-role");
  },
  getAffiliationList() {
    return Service.get("/api/show-affiliation-for-select");
  },
  getTitleName() {
    return Service.get("/api/get-title-name");
  },
  getRank() {
    return Service.get("/api/get-rank-name");
  },
  getResearchType() {
    return AuthService.get("/api/show-researcher-type");
  },
  showResearcherName() {
    return AuthService.get("/api/show-researcher-name");
  },
  getBudgetList(id) {
    // console.log(id);
    return AuthService.get(`/api/show-budget-resource/${id}`);
  },
  getParticipantList() {
    return AuthService.get("/api/show-participant");
  },
  getCertificate() {
    return AuthService.get("/api/get-certificate");
  },
  getNews() {
    return Service.get("/api/get-home-news");
  },
  getNewsByID(id) {
    return Service.get(`/api/get-news-by-id/${id}`);
  },
  getAllNews(page) {
    return Service.get("/api/get-all-news?page=" + page);
  },
  uploadCertificate(data) {
    // console.log('Certificate:', data)
    let formData = new FormData();
    formData.append("certificate", data.certificate_gcp_training);
    formData.append("certificate_create_at", data.certificate_date);
    return AuthService.post("/api/upload-certificate", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getLastMonthMeeting() {
    return Service.get("/api/get-last-month-meeting");
  },
  getThisMonthMeeting() {
    return Service.get("/api/get-this-month-meeting");
  },
  getAllMeeting() {
    return Service.get("/api/get-all-past-meeting");
  },
  saveParty(data) {
    return AuthService.post("/api/create-affiliation", data);
  },
  deleteParty(id) {
    return AuthService.delete(`/api/delete-affiliation/${id}`);
  },
  updateParty(data) {
    return AuthService.put(`/api/update-affiliation/${data.id}`, data);
  },
  getPartyList() {
    return AuthService.get("/api/show-paginate-affiliation");
  },
  getResearcherTypeList() {
    return Service.get("/api/show-researcher-type");
  },
  uploadImage(data) {
    let formData = new FormData();
    switch (data.name) {
      case "image-profile":
        formData.append("profileImage", data.file);
        break;
      case "image-signature":
        formData.append("signatureImage", data.file);
        break;
    }
    return Service.post("/api/upload-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => {
      return res;
    });
  },
  uploadPdf(data) {
    console.log(data);
    let formData = new FormData();
    switch (data.form) {
      case "rf03":
        formData.append("rf03affiliationFile", data.file);
        break;
      case "rf04_1":
        formData.append("rf04_1affiliationFile", data.file);
        break;
      case "rf04_2":
        formData.append("rf04_2affiliationFile", data.file);
        break;
      case "rf05":
        formData.append("rf05affiliationFile", data.file);
        break;
      case "rf06":
        formData.append("rf06affiliationFile", data.file);
        break;
      case "rf07":
        formData.append("rf07affiliationFile", data.file);
        break;
      case "rf12":
        formData.append("rf12affiliationFile", data.file);
        break;
      case "rf12-file":
        formData.append("rf12File", data.file);
        break;
      case "rf-susar":
        formData.append("rfSusar", data.file);
        break;
    }
    return AuthService.post("/api/upload-file-post", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => {
      return res;
    });
  },
  onUploadFile(data) {
    console.log('service data', data)
    let formData = new FormData();
    console.log("data", data);
    if (data.name === "amendments") {
      formData.append("name", data.name);
      data.file.forEach((file, i) => {
        formData.append(`file[${i}]`, file);
      });
    } else {
      formData.append("name", data.name);
      formData.append("file", data.file);
    }
    console.log('requst', formData);

    return AuthService.post("/api/upload-file-sub-meet", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => {
      return res;
    });
  },
  onUploadFileMeet(data) {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("file", data.file);
    return AuthService.post("/api/upload-file-meet", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => {
      return res;
    });
  },
};

export default Common;
